import {I_ACCESS_TOKEN_PARAMS,_customFetch, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- ORGANISATIONS
// ---------------------------------

const ENDPOINT_OOODAYS = '/organisations';

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {

}

/**
 * Requete le endpoint organisations
 * Récupère la liste des organisations avec controle d'acces
 * @param param0
 */
const get = async ({accessToken}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - organisations - get...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_OOODAYS}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};



const organisationsEndpoints = {
  get,
};

export default organisationsEndpoints;
